import type { PreferredAiProvider, ProductKind, Project } from '../modules/projects/types.js';

interface WireProject {
  id: string;
  name: string;
  orgId: string;
  default?: boolean;
  isReferenceProject?: boolean;
  preferredAiProvider?: string | null;
  product?: string;
  users?: unknown[];
}

export const projectAdapter = {
  fromListResponse(payload: unknown): Project[] {
    const list = (payload as { workspaces?: WireProject[]; projects?: WireProject[] } | null)?.workspaces
      ?? (payload as { projects?: WireProject[] } | null)?.projects
      ?? [];
    return list.map(normalize);
  },

  fromGetResponse(payload: unknown): Project {
    const wire = (payload as { workspace?: WireProject; project?: WireProject; data?: WireProject } | null);
    const value = wire?.workspace ?? wire?.project ?? wire?.data;
    if (!value) throw new Error('Project response missing body.');
    return normalize(value);
  },

  normalize,
};

function normalize(wire: WireProject): Project {
  return {
    id: wire.id,
    name: wire.name,
    orgId: wire.orgId,
    default: wire.default ?? false,
    isReferenceProject: wire.isReferenceProject ?? false,
    preferredAiProvider: (wire.preferredAiProvider ?? null) as PreferredAiProvider | null,
    product: (wire.product ?? 'cloud') as ProductKind,
    users: (wire.users ?? []) as Project['users'],
  };
}

// TODO(backend-cleanup): cloud-agent-backend internal/http/routes/project/project.go
// still returns `workspaces` / `workspace` keys. When those are renamed to
// `projects` / `project`, this adapter can fall through to a plain unwrap.
